import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description PopularSchools icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { PopularSchools } from '@sravni/design-system-icons'
 *
 * <PopularSchools />
 * ```
 */
var PopularSchools = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "PopularSchools", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M15.833 18.333H4.167c-.921 0-1.667-.745-1.667-1.666V3.333c0-.92.746-1.666 1.667-1.666h11.666c.921 0 1.667.746 1.667 1.666v13.334c0 .92-.746 1.666-1.667 1.666Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.333 12.5H6.667M11.667 15H8.333M10 8.886l1.253.658c.245.128.53-.079.483-.35l-.24-1.397 1.015-.987a.333.333 0 0 0-.184-.568l-1.402-.203-.627-1.27a.333.333 0 0 0-.596 0l-.627 1.27-1.402.204a.333.333 0 0 0-.184.568l1.014.987-.239 1.396a.333.333 0 0 0 .483.351L10 8.885", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { PopularSchools };
//# sourceMappingURL=PopularSchools.js.map
